import { oz } from '@weft/utils';
import { ProductSchema } from '../../../entities';
import { ObjectIdSchema } from '../../../primitives';
import { INVOICE_CREATED_EVENT_PAYLOAD_TYPES } from './invoice-created-event-payload-types';

export const InvoiceCreatedFromPricingEventPayloadSchema = oz.object({
  type: oz.literal(INVOICE_CREATED_EVENT_PAYLOAD_TYPES.FROM_PRICING),
  invoiceId: ObjectIdSchema,
  products: oz.array(ProductSchema),
});

export type InvoiceCreatedFromPricingEventPayload = oz.infer<typeof InvoiceCreatedFromPricingEventPayloadSchema>;